import React, {Component} from 'react';
import {NotificationManager} from 'react-notifications';
import compose from 'recompose/compose';
import {withStyles} from '@material-ui/core/styles';
import {resourceCustomUsers, sendForgotPasswordLetterEndPoint} from '../../constants';
import {Link} from 'react-router-dom';
import ForgotPasswordForm from './ForgotPasswordForm';
import {FETCH} from '../../fetchApi/types';
import {withTranslation} from 'react-i18next';
import {simpleDataProvider} from '../../fetchApi';

const styles = {
    changeTabLink: {
        display: 'inline',
        textDecoration: 'underline',
        color: '#FFFFFF'
    },
    suggestion: {
        color: '#000000',
        fontSize: '14px',
        marginTop: '4px',
    }
};

class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };
    }

    sendEmail = (auth) => {
        const {t: translate, history} = this.props;
        if (auth.email) {
            auth.email = auth.email.trim();
        }

        this.setState({loading: true});

        simpleDataProvider(FETCH, `${resourceCustomUsers}/${sendForgotPasswordLetterEndPoint}`, auth).then(() => {
            NotificationManager.success(translate('forgot_password.change_password_email_sent') + auth.email);
            history.push('/signin');
        }).catch(err => {
            NotificationManager.error(err.message, translate('common.notifications.error_title'));
        }).finally(() => {
            this.setState({loading: false});
        });
    };

    render() {
        const {classes, loading, t: translate} = this.props;

        return (
            <div className="rct-session-wrapper" style={{display:'flex'}}>
                <div className="session-inner-wrapper" style={{alignSelf: 'center', width: '100%', transform: 'translate3d(0%, -10%, 0)'}}>
                    <div className="container">
                        <div className="row row-eq-height" style={{flexDirection: 'column'}}>
                            <div className="col-sm-7 col-md-7 col-lg-8">
                                <div className="session-body text-center">
                                    <div className="session-head mb-30">
                                        <h2 className="font-weight-bold">{translate('forgot_password.forgot_password')}</h2>
                                    </div>
                                    <ForgotPasswordForm isLoading={loading} onSubmit={this.sendEmail} />
                                    <p className={classes.suggestion}>
                                        {translate('common.actions.click')}&nbsp;
                                        <Link to="/signin">
                                            {translate('common.here')}
                                        </Link>
                                        &nbsp;
                                        {translate('common.toLowercase')}&nbsp;
                                        {translate('widgets.signIn')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const EnhancedForgotPassword = compose(
    withTranslation(),
    withStyles(styles)
)(ForgotPassword);

export default EnhancedForgotPassword;